import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';

export interface DialogData {
    icon : string;
    text : string;
}

@Component({
    selector: 'app-message-box',
    standalone: true,
    templateUrl: './message-box.component.html',
    styleUrl: './message-box.component.scss',
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
    ],
})
export class MessageBoxComponent {
  
    constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}
